var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "900.000000pt",
    height: "900.000000pt",
    viewBox: "0 0 900.000000 900.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,900.000000) scale(0.100000,-0.100000)",
    fill: "#ff0000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746 8234 c-405 -405 -736 -741 -736 -747 0 -7 669 -681 1487 -1499 819 -819 1489 -1492 1491 -1498 2 -6 -667 -681 -1487 -1501 -820 -820 -1491 -1496 -1491 -1502 0 -15 1462 -1477 1477 -1477 6 0 682 671 1502 1491 820 820 1495 1489 1501 1487 5 -1 679 -672 1498 -1491 818 -818 1492 -1487 1499 -1487 6 0 342 331 747 736 602 602 734 739 727 752 -6 9 -676 683 -1490 1497 -815 814 -1481 1486 -1481 1494 0 7 660 674 1468 1481 807 807 1478 1479 1492 1494 l24 27 -729 730 c-402 402 -738 734 -747 740 -13 7 -285 -260 -1506 -1481 -820 -820 -1496 -1490 -1504 -1490 -7 0 -679 666 -1493 1481 -814 814 -1487 1484 -1497 1490 -13 7 -151 -126 -752 -727z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.7420cac40b11f0847e64bf79ca06ae29.svg";
export { ForwardRef as ReactComponent };